import styled from "styled-components";

export const NotificationsList = styled.div`
  width: 100%;
  h2 {
    font-weight: 300;
  }
  .notifications-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin: 30px 0 10px;
    span {
      margin-right: 10px;
    }
    div {
      width: 100%;
      border-bottom: 1px solid #c1c1c1;
    }
  }
  .notifications {
    &__item {
      padding: 10px;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
      margin-bottom: 5px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &.unseen {
        background: #f1f1f1;
        border: 1px solid #c1c1c1;
      }
      h4 {
        font-weight: 400;

        b {
          font-weight: 700;
        }
      }
      p {
        font-size: 0.87rem;
      }
      i {
        margin-right: 20px;
      }
    }
  }
`;
